import React from 'react';
import {Switch, Route, Redirect, useHistory} from 'react-router-dom';
import Income from './pages/Income';
import Balance from './pages/Balance';
import Client from './pages/Client';
import Redeem from './pages/Redeem';
import Maker from './pages/Maker';
import Invite from './pages/Invite';
import Status from './pages/Status';
import Security from './pages/Security';
import Account from './pages/Account';
import Telegram from './pages/Telegram';
import Withdraws from './pages/Withdraws';
import Shop from './pages/Shop';
import Diagnostics from './pages/Diagnostics';
import Five from './pages/Five';
import Free from './pages/Free';
import Edu from './pages/Edu';
import Message from './pages/Message';
import Services from './pages/Services';
import Test from './pages/Test';
import Fund from './pages/Fund';
import Checkout from './pages/Checkout';
import Monitor from './pages/Monitor';
import Notification from './pages/Notification';

import Settings from './settings/Settings';
import Shadowrocket from './settings/Settings.shadowrocket';
import Router from './settings/Settings.router';
import Terminal from './settings/Settings.terminal';
import Surge from './settings/Settings.surge';
import Surfboard from './settings/Settings.surfboard';
import V2Ray from './settings/Settings.v2ray';
import Singbox from './settings/Settings.singbox';
import Mihomo from './settings/Settings.mihomo';

import iOS from './settings/Settings.iOS';
import mac from './settings/Settings.mac';
import windows from './settings/Settings.windows';
import linux from './settings/Settings.linux';
import android from './settings/Settings.android';
import cfa from './settings/Settings.cfa';
import cfw from './settings/Settings.cfw';
import clashx from './settings/Settings.clashx';
import stash from './settings/Settings.stash';
import fl from './settings/Settings.flclash';

import tv from './settings/Settings.tv';
import Wireguard from './settings/Wireguard';
import Nintendo from './settings/Settings.switch';

import Rules from './pages/Rules';
import Success from './pages/Success';
import Report from './pages/Report';
import Giftcard from './pages/Giftcard';
import Checkin from './pages/Checkin';
import Device from './pages/Device';
import GPT from './pages/GPT';
import Tools from './pages/Tools';
import Invites from './pages/Invites';
import Receipt from './pages/Receipt';
import Receipt2 from './pages/Receipt2';

function AllRouters(){

  const history = useHistory();
  React.useEffect(() => {
    trackPageView(); // To track the first pageview upon load
    history.listen(trackPageView); // To track the subsequent pageviews
  }, [history]);
  function trackPageView() {

    //if google analytics is set
    if(typeof window.gtag == "function"){
      window.gtag("set", "page", window.location.pathname);
      window.gtag("send", "pageview");
      console.log(window.location.pathname);
    }

  }

  return (
    <Switch>
        <Route exact path='/console' component={Services} />
        <Route path='/console/income' component={Income} />
        <Route path='/console/checkin' component={Checkin} />
        <Route path='/console/device' component={Device} />
        <Route path='/console/giftcard' component={Giftcard} />
        <Route path='/console/report' component={Report} />
        <Route path='/console/clash' component={Settings} />
        <Route path='/console/flclash' component={fl} />
        <Route path='/console/cfa' component={cfa} />
        <Route path='/console/cfw' component={cfw} />
        <Route path='/console/clashx' component={clashx} />
        <Route path='/console/stash' component={stash} />
        <Route path='/console/mihomo' component={Mihomo} />
        <Route path='/console/rules' component={Rules} />
        <Route path='/console/v2ray' component={V2Ray} />
        <Route path='/console/singbox' component={Singbox} />
        <Route path='/console/tv' component={tv} />
        <Route path='/console/wireguard' component={Wireguard} />
        <Route path='/console/ios' component={iOS} />
        <Route path='/console/mac' component={mac} />
        <Route path='/console/linux' component={linux} />
        <Route path='/console/windows' component={windows} />
        <Route path='/console/android' component={android} />
        <Route path='/console/shadowrocket' component={Shadowrocket} />
        <Route path='/console/surge' component={Surge} />
        <Route path='/console/surfboard' component={Surfboard} />
        <Route path='/console/switch' component={Nintendo} />
        <Route path='/console/router' component={Router} />
        <Route path='/console/terminal' component={Terminal} />



        <Route path='/console/balance' component={Balance} />
        <Route path='/console/success' component={Success} />
        <Route path='/console/invites' component={Invites} />
        <Route path='/console/invite' component={Invite} />
        <Route path='/console/redeem' component={Redeem} />
        <Route path='/console/maker' component={Maker} />
        <Route path='/console/status' component={Status} />
        <Route path='/console/account' component={Account} />
        <Route path='/console/telegram' component={Telegram} />
        <Route path='/console/withdraws' component={Withdraws} />
        <Route path='/console/shop' component={Shop} />
        <Route path='/console/client' component={Client} />
        <Route path='/console/diagnostics' component={Diagnostics} />
        <Route path='/console/free' component={Free} />
        <Route path='/console/message' component={Message} />
        <Route path='/console/education' component={Edu} />
        <Route path='/console/test' component={Test} />
        <Route path='/console/fund' component={Fund} />
        <Route path='/console/checkout/:level' component={Checkout} />
        <Route path='/console/checkout' component={Checkout} />
        <Route path='/console/monitor' component={Monitor} />
        <Route path='/console/security' component={Security} />
        <Route path='/console/tools' component={Tools} />
        <Route path='/console/openai' component={GPT} />
        <Route path='/console/notification' component={Notification} />
        <Route path='/console/receipt/:id' component={Receipt} />
        <Route path='/console/receipt2/:id' component={Receipt2} />
    </Switch>

  )

}

export default AllRouters;
